export interface TranslationState {
  [index: string]: boolean;
}

// eslint-disable-next-line
export const isTranslated = (obj: any): boolean => {
  // check the whole object
  if (obj && typeof obj === 'object') {
    return Object.keys(obj).every((key) =>
      key === 'translated'
        ? obj[key] && Object.keys(obj[key]).every((prop) => obj[key][prop])
        : isTranslated(obj[key]),
    );
  } else if (obj && Array.isArray(obj)) {
    return obj.every((o) => isTranslated(o));
  }

  return true;
};

export const notTranslatedKeys = (state: TranslationState): string[] => {
  return Object.keys(state).filter((key) => !state[key]);
};
